<template>
  <Catalog
    title="Источник исполнителя"
    name-label="Название источника"
    submit-error="Укажите название источника исполнителей."
    description-label="Например: Авито, HeadHunter, Рекомендация"
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "WorkerSource",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getWorkerSourceById(id);
    },
    async putData(data) {
      return await this.putWorkerSource(data)
    },
    async postData(data) {
      return await this.postWorkerSource(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerSources/WorkerSource.vue